import { DatePipe } from "@angular/common";
import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import moment, { duration } from "moment";
import { TIMESHEET_STATUS } from "../../../constant/constant";
import { ActivityService } from "../../../services/acitvity.service";
import { CategoryService } from "../../../services/category.service";
import { TimesheetService } from "../../../services/timesheet.service";
import { UserService } from "../../../services/user.service";
import saveAs from "file-saver";
import { ExportExcel } from "../../../constant/ExcelExport";
import type { ResponseForReport } from "../../../constant/response";
import type { CategoryDTO } from "../../category/category.model";
import type { CategoryReport } from "../../../constant/categoryReport";
import { HttpErrorResponse } from "@angular/common/http";
import { ResponseCommonForList } from "../../../dtos/ResponseDTOs";
import { MultiSelectSearch } from "../../../helper/MultiSelectSearch";
import { Activity } from "../../../dtos/Activity";
import { Category } from "../../../dtos/Category";
import type { IdName } from "../../../dtos/IdName";
import { RoleEnum } from "../../../enums/role.enum";



export interface ReportCategory {
  categoryId: number;
  category: string;
  noOfHours : number;
}
@Component({
  selector: 'app-category-report',
  templateUrl: './category-report.component.html',
  styleUrl: './category-report.component.css',
  standalone: false
})
export class CategoryReportComponent implements OnInit{
    
  userData: any;
  categoryList: Category[] = [];
  activityList: Activity[] = [];
  usersForFilter: IdName[] = [];
  filterActivityList: Activity[] = [];
  filterForm: FormGroup;
  timeSheetStatus:IdName[] = TIMESHEET_STATUS;
  selectedCategoryIds: number[] = [];
  selectedActivityIds: number[] = [];
  selectedUserIds: number[] = [];
  selectedStatusIds: number[] = [];
  dataSource = new MatTableDataSource<CategoryReport>([]);
  activities: Activity[] = [];
    
  categoryReport: CategoryReport[] = [];
  isAdmin: boolean = false;
  isTeamlead: boolean = false;
  isDepartmentAdmin: boolean = false;

  @Output() isExcelBeingDownloaded = new EventEmitter<boolean>();
  isExcelExporting: boolean = false;
  exportButtonText: string = 'Export Category Report';

  displayedColumns: string[] = ['category', 'noOfHours'];

  categorySearch: MultiSelectSearch<IdName>;
  activitySearch: MultiSelectSearch<IdName>;
  userSearch: MultiSelectSearch<IdName>;
  statusSearch: MultiSelectSearch<IdName>;
  
  constructor(
    private userService: UserService,
    private categoryService: CategoryService,
    private activityService: ActivityService,
    private timesheetService: TimesheetService,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    public datePipe: DatePipe,
    private exportData: ExportExcel
  ){
    this.filterForm = this.formBuilder.group({
      workDate: [''],
      categoryIds: [[], ],
      activityIds: [[], ],
      userIds: [[], ],
      status: [[],],
      startDate: [''],
      endDate: ['']
    });

    this.categorySearch = new MultiSelectSearch<IdName>(this.filterForm.get('categoryIds') as FormControl, [], (value) => this.onfilterCategorySelection(value));
    this.activitySearch = new MultiSelectSearch<IdName>(this.filterForm.get('activityIds') as FormControl,[]);
    this.userSearch = new MultiSelectSearch<IdName>(this.filterForm.get('userIds') as FormControl, []);
    this.statusSearch = new MultiSelectSearch<IdName>(this.filterForm.get('status') as FormControl, this.timeSheetStatus);
  }
  
  ngOnInit(): void {
    this.getStorageData();  
    this.getAllUserIdNameForFilter();
    this.filterForm.get("startDate")?.reset();
    this.filterForm.get("endDate")?.reset();
    this.getAllCategory();
    this.filterForm.get("startDate")?.setValue(moment());
    this.filterForm.get("endDate")?.setValue(moment());
    this.getCategoryReport();
  }
  
  getStorageData(){
    let user:any = sessionStorage.getItem("userData");
    this.userData = JSON.parse(user);
    this.isAdmin = Number(this.userData.roleId) == RoleEnum.ADMIN;
    this.isTeamlead = Number(this.userData.roleId) == RoleEnum.TEAMLEAD;
    this.isDepartmentAdmin = Number(this.userData.roleId) == RoleEnum.DEPARTMENT_ADMIN;
  }
  
  getAllUserIdNameForFilter(): void {
      this.userService.getUserIdNameList().subscribe({
        next: (res: ResponseCommonForList<IdName>) => {
          this.usersForFilter = res.responseObject;
          this.userSearch.setOptions(this.usersForFilter);
        },
        error: (err: HttpErrorResponse) => {
          console.error("Error getting UserIdNameList for Filter", err.message);
        }
      });
    }
  
  onfilterCategorySelection(categoryIds: number[]): void {
      if (categoryIds && categoryIds.length > 0) {
        const categoryTypeIds = this.categoryList.filter(c => categoryIds.includes(c.id)).map(category => category.categoryTypeId);
        this.getFilterActivityList(categoryTypeIds);
      } else {
        this.filterActivityList = [];
        this.filterForm.get('activityIds')?.reset();
      }
    }
  
    getAllCategory(): void {
      this.categoryService.getAllCategory().subscribe({
        next: (res: ResponseCommonForList<Category>) => {
          this.categoryList = res.responseObject;
          this.categorySearch.setOptions(this.categoryList.map((c: IdName) => ({ id: c.id, name: c.name })));
        },
        error: (err: HttpErrorResponse) => {
          console.error("Error getting List of Category", err.message);
        }
      });
    }
  
    getFilterActivityList(categoryTypeIds: number[]): void {
      this.activityService.getActivityByCategoryTypeIds(categoryTypeIds).subscribe({
        next: (res: ResponseCommonForList<Activity>) => {
          this.filterActivityList = res.responseObject;
          this.activitySearch.setOptions(this.filterActivityList.map((a: IdName) => ({id: a.id, name: a.name})));
          if (this.filterActivityList.length == 1 && this.filterForm.get("categoryIds")?.value != null) {
            this.filterForm.get("activityIds")?.setValue(this.filterActivityList[0].id)
          } else {
            this.filterForm.get("activityIds")?.reset()
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error("Error getting activityList by categoryTypeIds : ", err.message);
        }
      });
    }
  
    getActivityListByCategoryType(categoryTypeId: number): void {
      this.activityService.getActivityByCategoryTypeId(categoryTypeId).subscribe({
        next: (res: ResponseCommonForList<Activity>) => {
          this.activities = res.responseObject;
        },
        error: (err: HttpErrorResponse) => {
          console.error("Error getting Activities By CategoryTypeId:", err.message);
        }
      });
    }
  
  getCategoryReport() {
    const filterData = this.filterForm.value;
  
    filterData.workDate = this.datePipe.transform(filterData.workDate, 'yyyy-MM-dd');
    filterData.startDate = this.datePipe.transform(filterData.startDate, 'yyyy-MM-dd');
    filterData.endDate = this.datePipe.transform(filterData.endDate, 'yyyy-MM-dd');
    filterData.userIds = this.filterForm.get('userIds')?.value;
  
    if(!this.isAdmin && !this.isTeamlead && !this.isDepartmentAdmin){
      filterData.userIds = [this.userData.id];
    }

    this.timesheetService.getCategoryReport(filterData).subscribe({
      next: (res: ResponseForReport<CategoryReport>) => {
        this.categoryReport = res.responseObject;
        this.dataSource.data = this.categoryReport;
        this.snackBar.open(res.message, 'Close', {duration: 3000});
      }
    })
    // (response => {
    //   this.categoryReport = response.responseObject;
    //   this.dataSource.data = [...this.categoryReport];
    // })
  }

  currentDate = new Date();
  formatedDate: string | null  = this.datePipe.transform(this.currentDate, 'dd_MM_yyyy_HH_mm');

  exportCategoryReport(): void {
    let userId = this.userData.id;
    const filterData = this.filterForm.value;
    filterData.workDate = this.datePipe.transform(filterData.workDate, 'yyyy-MM-dd');
    filterData.startDate = this.datePipe.transform(filterData.startDate, 'yyyy-MM-dd');
    filterData.endDate = this.datePipe.transform(filterData.endDate, 'yyyy-MM-dd');
    filterData.userIds = this.filterForm.get('userIds')?.value;
    if(this.isAdmin) {
      userId = -1;
    }
    if(!this.isAdmin && !this.isTeamlead && !this.isDepartmentAdmin){
      filterData.userIds = [this.userData.id];
    }
    this.isExcelBeingDownloaded.emit(true);
    this.timesheetService.exportCategoryReport(filterData, userId).subscribe({

      next: (response : ResponseForReport<CategoryDTO>) => {
        if(response.responseObject != undefined && response.responseObject != null) {
          saveAs(this.exportData.base64ToBlob(response.responseObject), 'categoryReport_'+this.formatedDate);
        }

        this.snackBar.open(response.message, 'Close',
          {duration: 3000}
        );
        this.isExcelBeingDownloaded.emit(false);
      },
      error: (err) => {
        this.isExcelBeingDownloaded.emit(false);
        this.snackBar.open(err.message, 'Close', {duration: 3000});
      }
    })
  }


  excelExportButtonStatus(value:any){
    this.isExcelExporting = value;
    if(value){
      this.exportButtonText = 'Exporting... ';
    }else{
      this.exportButtonText = 'Export Timesheet';
    }
  }
  
  onFilter(): void {
    this.getCategoryReport();
  }
  
  clearFilter(){
    this.filterForm.reset({ workDate: '',categoryIds : [], activityIds: [], userIds: [],startDate : moment(), endDate: moment() });
    this.getCategoryReport();
  }
}
